const FRESH_TTL = 12 * 60 * 60 * 1000; // 12 hours
const STALE_TTL = 7 * 24 * 60 * 60 * 1000; // 7 days

/**
 * Retrieve cached data by key.
 * Returns fresh data normally, stale data only when allowStale is true.
 * @param {string} cacheKey - Unique identifier for cached data
 * @param {boolean} allowStale - If true, return data up to 7 days old
 * @returns {Object|null} Cached data or null if not found or expired
 */
export const getCache = (cacheKey, allowStale = false) => {
  try {
    const cachedData = localStorage.getItem(cacheKey);
    if (!cachedData) return null;

    const { data, timestamp } = JSON.parse(cachedData);
    const age = Date.now() - timestamp;

    // Fresh cache: within 12 hours
    if (age <= FRESH_TTL) {
      return data;
    }

    // Stale cache: within 7 days, only if caller allows it
    if (allowStale && age <= STALE_TTL) {
      return data;
    }

    // Expired — remove it
    localStorage.removeItem(cacheKey);
    return null;
  } catch (error) {
    console.error('Error retrieving cache:', error);
    return null;
  }
};

/**
 * Store data in cache with current timestamp
 * @param {string} cacheKey - Unique identifier for cached data
 * @param {Object} data - Data to cache
 */
export const setCache = (cacheKey, data) => {
  try {
    const cacheData = {
      data,
      timestamp: Date.now()
    };
    localStorage.setItem(cacheKey, JSON.stringify(cacheData));
  } catch (error) {
    console.error('Error setting cache:', error);
  }
};
